// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__28N53","choiceBoxes":"toolbarselects_choiceBoxes__EPtMe","simpleField":"toolbarselects_simpleField__1daUq"};